<template>
  <div class="map-elem-info-area compare-mode">
    <div class="confirm-create" v-if="!mapElemInfo">
      <img class="map-elem-icon" :src="mapElemIconPath">
      <button
        type="button"
        class="btn btn-secondary"
        @click="$emit('startCreate')"
        :disabled="!currentMgi"
      >
        現在位置に付箋を追加
      </button>
    </div>
    <MapElemInfoNew
      v-else
      :elem="mapElemInfo"
      :visible-layers="visibleGeoItemLayers"
      :force-show-cancel-button="true"
      :create-failed="createFailed"
      @create="$emit('create', $event)"
      @cancel-edit="$emit('cancelEdit')"
    />
  </div>
</template>

<script setup lang="ts">
import MapElemInfoNew from 'src/components/Top/mapElemInfoComponents/MapElemInfoNew.vue';
import type { GeoItemMeta, GIComment, GIMovieGeoIndex } from 'src/models/geoItem';
import type { MapElemInfo } from 'src/models';
import type { CompareModeMapElemInfoState } from 'src/models/moviePlayer';

defineProps<{
  mapElemInfo: CompareModeMapElemInfoState | null;
  mapElemIconPath: string;
  visibleGeoItemLayers: GeoItemMeta[];
  currentMgi: GIMovieGeoIndex | null;
  createFailed: number;
}>();

defineEmits<{
  (e: 'startCreate'): void;
  (e: 'create', obj: MapElemInfo<GIComment>): void;
  (e: 'cancelEdit'): void;
}>();
</script>

<style lang="scss" scoped>
.confirm-create {
  padding: 6px 8px;
}
.map-elem-icon {
  width: 42px;
}
</style>
